// 顶部BANNER POSTER 高度
export const TOP_BANNER_HEIGHT = 60

// 顶部导航条高度
export const TOP_HEADER_HEIGHT = 64

// 左侧一级菜单宽度
export const LEFT_MENU_LEVEL1_WIDTH = 96

// 左侧二级菜单宽度
export const LEFT_MENU_LEVEL2_WIDTH = 112

// 加盟店左侧菜单宽度
export const LEFT_MENU_JIAMENG_WIDTH = 80
